import { AxiosResponse } from "axios";
import { endPoints } from "utils/constants";
import { crudService } from "services/crud.service";
import { NotificationManager } from "react-notifications";
import { getErrorMessage, getPaginatedUrlWithSearchParams } from "store/helper";
import { createAsyncThunk, PayloadAction, createSlice } from "@reduxjs/toolkit";
import { defaultMetaObj, initialAllActivitiesState } from "store/constants";
import { getLeadByLeadId } from "utils/helpers";

const { allActivityEndPoint } = endPoints;

export const fetchAllActivities = createAsyncThunk(
  "activities/fetchAllActivities",
  async (
    {
      page,
      limit,
      searchParamsObj = {},
    }: { page: number; limit?: number; searchParamsObj?: {} },
    { rejectWithValue }
  ) => {
    const paginatedUrl = getPaginatedUrlWithSearchParams({
      pageNumber: page,
      limit,
      endpoint: allActivityEndPoint,
      searchParams: {
        ...searchParamsObj,
      },
    });

    try {
      const response: AxiosResponse = await crudService.getAll(paginatedUrl);

      let result = await response.data.objects.map(async (item: any) => {
        const leadData = item?.link_lead_id
          ? await getLeadByLeadId({ lead_id: item?.link_lead_id })
          : {};

        return {
          ...item,
          leadData,
        };
      });

      return { ...response.data, result: (await Promise.all(result)) || [] };
    } catch (error: any) {
      const errorMessage = getErrorMessage(error);

      NotificationManager.error(errorMessage);
      return rejectWithValue(error.message);
    }
  }
);

export const deleteActivity = createAsyncThunk(
  "activities/deleteActivity",
  async ({ activityId }: any, { rejectWithValue }) => {
    try {
      const response: any = await crudService.delete(
        allActivityEndPoint,
        activityId
      );

      if (response.status === 204) {
        NotificationManager.success("Activity Deleted Successfully.");
        return response.data;
      }
    } catch (error: any) {
      const errorMessage = getErrorMessage(error);

      NotificationManager.error(errorMessage);
      return rejectWithValue(error.message);
    }
  }
);

const activitySlice = createSlice({
  name: "activities",
  initialState: initialAllActivitiesState,
  reducers: {},
  extraReducers: (builder) => {
    // fetch all call records
    builder
      .addCase(fetchAllActivities.pending, (state: any) => {
        state.loading = true;
      })
      .addCase(
        fetchAllActivities.fulfilled,
        (state: any, action: PayloadAction<any>) => {
          state.loading = false;
          state.activities = action.payload?.result as any[];
          state.meta = action.payload?.meta;
        }
      )
      .addCase(
        fetchAllActivities.rejected,
        (state: any, action: PayloadAction<any>) => {
          state.loading = false;
          state.error = action.payload as string;
          state.activities = [];
          state.meta = defaultMetaObj;
        }
      );

    // delete Call Record
    builder
      .addCase(deleteActivity.pending, (State) => {
        State.loading = true;
      })
      .addCase(
        deleteActivity.fulfilled,
        (state, action: PayloadAction<any>) => {
          state.loading = false;
        }
      )
      .addCase(
        deleteActivity.rejected,
        (state: any, action: PayloadAction<any>) => {
          state.loading = false;
          state.error = action.payload as string;
        }
      );
  },
});

export const allActivityReducer = activitySlice.reducer;
